﻿
(function ($, document) {

    function InitializeEllipsis() {
        $('.js-ellipse').dotdotdot({
            ellipsis: '...',
            fallbackToLetter: true,
            wrap: 'word'
        });
    }

    $(document).on('Ellipsis.Page_OnRefresh', function (e) {
        InitializeEllipsis();
    });

    $(document).ready(function() {
        InitializeEllipsis();
    });
})(jQuery, document);